import ManageIndex from '@/views/common/Index'
import Main from '@/views/common/Main'
import Redirect from '@/views/common/Redirect'


export default [{
	path: '/manageIndex',
	name: 'ManageIndex',
	meta: {
		auth: true
	},
	component: ManageIndex,
	children: [{
			path: '/publish',
			component: Main
		},
		// // 富文本文件重定向
		// {
		// 	path: '/evaluation/redirect',
		// 	meta: {
		// 		auth: false,
		// 		isRedirect: true
		// 	},
		// 	component: Redirect,
		// 	children: [{
		// 		path: '/',
		// 		name: 'evaluation/redirect',
		// 		meta: {
		// 			keepAlive: true
		// 		},
		// 		component: resolve => require(['@/views/common/Redirect'], resolve)
		// 	}]
		// },
		]
	
}]



// WEBPACK FOOTER //
// ./src/router/publish.js